import { fetchRecordByKey } from "../../services/IndexedDBUtil";

export function stage4PreparePayload(formData) {
    const payload = JSON.parse(`{
    "temporalSettings" : {
      "user_id": "",
      "workflow_id": "",
      "data_upload_id": "",
      "start_date": "",
      "end_date": "",
      "data_frequency": "",
      "forecast_frequency": "",
      "forecast_period": "",
      "train_percentage":"",
      "test_percentage": ""
    },
    "skuList": [],
    "geolevels": []
  }`);

    payload.temporalSettings.user_id = formData.user_id;
    payload.temporalSettings.start_date = formData.stage2.start_date;
    payload.temporalSettings.end_date = formData.stage2.end_date;
    payload.temporalSettings.workflow_id = formData.stage1.data_upload_id ? formData.stage1.data_upload_id : formData.id;
    payload.temporalSettings.data_upload_id = formData.stage1.data_upload_id ? formData.stage1.data_upload_id : formData.id;
    payload.temporalSettings.data_frequency = formData.stage2.data_frequency;
    payload.temporalSettings.forecast_frequency = formData.stage2.forecast_frequency;
    payload.temporalSettings.forecast_period = extractNumber(formData.stage2.forecast_period);
    payload.temporalSettings.train_percentage = formData.stage2.train_percentage;
    payload.temporalSettings.test_percentage = formData.stage2.test_percentage;
    const selectedProducts = formData?.stage3?.products?.length
        ? formData.stage3.products
        : formData?.stage3?.featureBasedForecasting?.selected_skus || [];

    payload.skuList = convertProductsToSkuList(selectedProducts);
    payload.geolevels = convertGeographyData(formData?.stage3?.geography);

    return payload;
}

function parseIdPart(value) {
    const numericValue = Number(value);
    return Number.isFinite(numericValue) ? numericValue : value;
}

function convertProductsToSkuList(products) {
    if (!products) {
        return [];
    }
    return products.map((product) => {
        const { id, breadcrumb } = product;

        const hasFeatureSkuShape = Boolean(
            product.sku_code ||
            product.skuCode ||
            product._skuCode ||
            product.sku_id ||
            product.skuId ||
            product.sku_name ||
            product.skuName ||
            product._description ||
            product.description ||
            product.skuDescription
        );
        const skuCode = product.sku_code || product.skuCode || product._skuCode || product.code || product.id || product.sku_id || product.skuId;
        const skuName = product.sku_name || product.skuName || product._description || product.description || product.skuDescription || product.name || skuCode;

        if (hasFeatureSkuShape) {
            return {
                sku_id: product.sku_id || product.skuId || skuCode,
                sku_name: skuName,
                level1_id: product.level1_id ?? 0,
                level2_id: product.level2_id ?? 0,
                level3_id: product.level3_id ?? 0,
                level4_id: product.level4_id ?? 0,
                level5_id: product.level5_id ?? 0,
                level6_id: product.level6_id ?? product.sku_id ?? product.skuId ?? skuCode,
                combination: product.combination || product._combination || skuName
            };
        }

        if (product.sku_id || product.skuId) {
            return {
                sku_id: product.sku_id || product.skuId,
                sku_name: product.sku_name || product.skuName || breadcrumb?.split("\\").pop() || "",
                level1_id: product.level1_id ?? 0,
                level2_id: product.level2_id ?? 0,
                level3_id: product.level3_id ?? 0,
                level4_id: product.level4_id ?? 0,
                level5_id: product.level5_id ?? 0,
                level6_id: product.level6_id ?? product.sku_id ?? product.skuId ?? 0,
                combination: product.combination || breadcrumb || ""
            };
        }

        const [level1_id = 0, level2_id = 0, level3_id = 0, level4_id = 0, level5_id = 0, level6_id = 0] = String(id || "").split("_").map(parseIdPart);

        const sku_name = breadcrumb.split("\\").pop();
        return {
            sku_id: level6_id,
            sku_name,
            level1_id,
            level2_id,
            level3_id,
            level4_id,
            level5_id,
            level6_id,
            combination: breadcrumb
        };
    });
}

function convertGeographyData(geography) {
    if (!geography) {
        return [];
    }
    return geography.map((geo) => {
        const { id, breadcrumb } = geo;

        // Extract levels from id, fill missing levels with null
        const [level1_id = null, level2_id = null, level3_id = null, level4_id = null, level5_id = null] = id.split("_");

        // Split breadcrumb into parts and fill missing levels with empty string
        const [level1 = "", level2 = "", level3 = "", level4 = "", level5 = ""] = breadcrumb.split("\\");

        // Construct the desired object
        return {
            level1,
            level2,
            level3,
            level4,
            level5,
        };
    });
}

/**
 * Extracts the first number from a given string.
 * @param {string} str - The input string.
 * @returns {number|null} - The extracted number or null if no number is found.
 */
function extractNumber(str) {
    const match = String(str ?? "").match(/\d+/);
    return match ? parseInt(match[0], 10) + 1 : null;
}

export const toggleErrorVisibility = (condition, inputControl, errorControl, errorMessage = "* Required") => {
    //console.log("condition", condition);
    if (condition) {
        inputControl?.classList?.add("highlighted");
        errorControl?.classList.add("visible");
        errorControl?.classList.remove("hidden");
        errorControl.innerText = errorMessage;
    } else {
        inputControl?.classList.remove("highlighted");
        errorControl?.classList.add("hidden");
        errorControl?.classList.remove("visible");
        errorControl.innerText = "";
    }
}

export function Stage4DummyTablePrep(products, geographies) {
    let TableData = [];

    // Helper function to generate random number within a range
    const getRandomNumber = (min, max) => {
        return Math.floor(Math.random() * (max - min + 1) + min);
    };

    // Generate all combinations
    for (let product of products) {
        for (let geo of geographies) {
            const availNumber = getRandomNumber(80000, 200000);
            const selectedCount = getRandomNumber(1000, 40000);

            const rowJSX = (
                <tr key={`${product.id}_${geo.id}`}>
                    <td>
                        <div className="">
                            <span>{product.breadcrumb.replaceAll("\\", " → ")}</span>
                        </div>
                    </td>
                    <td>
                        <div className="daselecteditem">
                            <span>{geo.breadcrumb.replaceAll("\\", " → ")}</span>
                        </div>
                    </td>
                    <td><span>{availNumber}</span></td>
                    <td><span>{selectedCount}</span></td>
                </tr>
            );
            TableData.push(rowJSX);
        }
    }

    // Create the complete table JSX
    const completeTableJSX = (
        <table className="table dataselectiontable table-bordered">
            <thead>
                <tr>
                    <th>Selected SKU'S</th>
                    <th>Selected Geographies</th>
                    <th>Total<br /> Available Data</th>
                    <th>Total<br /> Selected Data</th>
                </tr>
            </thead>
            <tbody>
                {TableData}
            </tbody>
        </table>
    );

    return completeTableJSX;
}

export async function Stage4TablePrep(response) {
    let rows = [];
    let res = await fetchRecordByKey("MyDatabase", "myStore", "SKUS", 1);
    if (res.success && res.record) {
        for (let combination of response.combinations) {
            let skuArray = [combination.sku];
            let geographyArray = [combination.geography];
            let _skuBreadcrumbs = getbreadcrumbs(skuArray, res.record.data)
            if (!_skuBreadcrumbs) return;
            rows.push({
                skuBreadcrumb: _skuBreadcrumbs,
                geoBreadcrumb: geographyArray.map((item) => {
                    // Collect levels into an array
                    const levels = [
                        item.level1,
                        item.level2,
                        item.level3,
                        item.level4,
                        item.level5,
                    ];
                    // Remove empty strings and concatenate with underscores
                    return levels.filter(level => level !== "").join("\\");
                })[0],

                train_threshold: combination.train_threshold,
                test_threshold: combination.test_threshold,

                train_data_available: combination.train_data_available,
                test_data_available: combination.test_data_available,

                sku: combination.sku,
                geography: combination.geography,
            });
        }
    }
    //console.log(rows)
    rows.sort((a, b) => b.train_data_available - a.train_data_available);
    return rows; // Return raw data for table rows
}

function getbreadcrumbs(sku, record) {
    return sku.map((item) => {
        // Get only non-zero level IDs from level1 to level6
        const levels = [
            item.level1_id,
            item.level2_id,
            item.level3_id,
            item.level4_id,
            item.level5_id,
            item.level6_id
        ];
        const validLevels = levels.filter(id => id !== 0);
        const idPrefix = validLevels.join('_');

        // Find matching record where record.id starts with the idPrefix
        const matched = record.find((rec) => rec.id.startsWith(idPrefix));

        if (matched) {
            const breadcrumbParts = matched.breadcrumb.split('\\');
            const resultBreadcrumb = breadcrumbParts.slice(0, validLevels.length).join('\\');
            return resultBreadcrumb;
        }

        return null;
    }).filter(Boolean)[0] || null; // return first match or null
}

const handleCheckboxChange = (e) => {
    console.log("Checkbox Changed", e.target.dataset);
    // Add your logic here to update your state based on the checkbox change
}

export function SubmitWorkflowPayloadPrep(formData) {
    const payload = JSON.parse(`{
            "modelInput": {
                "user_id": "",
                "workflow_id": "",
                "data_upload_id": "",
                "start_date": "",
                "end_date": "",
                "data_frequency": "",
                "forecast_frequency": "",
                "forecast_period": 0,
                "models_list": [],
                "forecast_horizon": 0,
                "workflow_desc": "",
                "workflow_name": ""
            },
    "skuSelections": [],
    "groups": []
        }`);

    payload.modelInput.user_id = formData.user_id;
    payload.modelInput.workflow_id = formData.id;

    payload.modelInput.data_upload_id = formData.stage1.data_upload_id;

    payload.modelInput.start_date = formData.stage2.start_date;
    payload.modelInput.end_date = formData.stage2.end_date;

    payload.modelInput.workflow_name = formData.stage1.workflow_name;
    payload.modelInput.workflow_desc = formData.stage1.workflow_description;

    payload.modelInput.data_frequency = formData.stage2.data_frequency;
    payload.modelInput.forecast_frequency = formData.stage2.forecast_frequency;
    payload.modelInput.forecast_period = extractNumber(formData.stage2.forecast_period);
    payload.modelInput.train_percentage = formData.stage2.train_percentage;
    payload.modelInput.test_percentage = formData.stage2.test_percentage;

    // Enhanced skuSelections with combination breadcrumbs from stage3
    const productMap = new Map(
        (formData.stage3?.products || []).map((product) => [product.id, product.breadcrumb])
    );

    payload.skuSelections = (formData.stage4?.combinations || []).map((elem) => {
        const sku = elem.sku || {};
        const productId = [
            sku.level1_id || 0,
            sku.level2_id || 0,
            sku.level3_id || 0,
            sku.level4_id || 0,
            sku.level5_id || 0,
            sku.level6_id || sku.sku_id || 0
        ].join("_");

        const combination = productMap.get(productId) || "";

        return {
            skuDetails: {
                ...sku,
                combination
            },
            geoDetails: normalizeGeoDetails(elem.geography)
        };
    });

    payload.modelInput.models_list = formData.stage6?.models || [];

    // Feature-Combination groups selected in Stage 3.
    // Groups are sent ONLY when the user chose the feature-based flow; SKU-based
    // forecasting (or any leftover feature draft from a discarded flow) sends [].
    // The selection is already persisted to formData (IndexedDB) on every
    // checkbox toggle in Stage 3, so it survives a refresh at any stage — here we
    // just read it back and reshape it for the API.
    payload.groups = buildGroupsPayload(formData);

    console.log("Final Payload:", payload);
    return payload;
}

// Reshape the persisted Stage 3 group selections into the API contract:
//   [{ group_name, items: [{ sku, description }] }]
// Returns [] unless the workflow is in feature-based mode with groups selected.
// Handles any number of selected groups.
export function buildGroupsPayload(formData) {
    const isFeatureMode =
        formData?.stage3?.forecastingType === "feature" &&
        Boolean(formData?.stage3?.featureBasedForecasting?.selected_combinations?.length);

    if (!isFeatureMode) return [];

    const selectedCombinations = formData.stage3.featureBasedForecasting.selected_combinations;

    return selectedCombinations.map((combo, index) => ({
        group_name: combo.groupLabel || `Group ${index + 1}`,
        items: (combo.skus || []).map((sku) => ({
            // Field priority matches Stage4's feature-mode matching for consistency
            sku: String(sku.sku_code ?? sku._skuCode ?? sku.sku_id ?? "").trim(),
            description: String(sku.sku_description ?? sku._description ?? sku.sku_name ?? "").trim(),
        })),
    }));
}

// Geography stored on a combination must reach the API as {level1..level5}.
// Older drafts may hold {id, breadcrumb} entries instead — convert those by
// splitting the breadcrumb so the API contract stays intact.
function normalizeGeoDetails(geography) {
    if (!geography || typeof geography !== "object") return geography;
    if (geography.level1 !== undefined && geography.level1 !== null) return geography;
    if (!geography.breadcrumb) return geography;

    const [level1 = "", level2 = "", level3 = "", level4 = "", level5 = ""] =
        String(geography.breadcrumb).split("\\");

    return { level1, level2, level3, level4, level5 };
}

export function filterSelectedItems(selectedItems, newItems) {
    // If newItems is a single item, convert it to an array
    const newItemsArray = Array.isArray(newItems) ? newItems : [newItems];
    //console.log(`newItemsArray`, newItemsArray)
    return selectedItems.filter(item => {
        const itemParts = item.id.split('_');

        // Check against each new item
        return !newItemsArray.some(newItem => {
            const newItemParts = newItem.id.split('_');

            // Check if current item is a parent path of newItem
            const isParentPath = newItemParts.length > itemParts.length &&
                itemParts.every((part, index) => part === newItemParts[index]);

            // Check if current item is a child of newItem
            const isChild = itemParts.length > newItemParts.length &&
                newItemParts.every((part, index) => part === itemParts[index]);

            // Return true if the item should be removed (is either parent or child)
            return isParentPath || isChild;
        });
    });
}

// ==================== SHARED PAGE / STAGE STYLES ====================

export const stageLayoutStyles = {
    wrapper: {
        width: "100%",
        padding: "0",
        boxSizing: "border-box",
        background: "transparent",
    },
    card: {
        width: "100%",
        background: "#fff",
        padding: "16px 20px 20px",
        borderRadius: 12,
        boxShadow: "0 3px 12px rgba(12, 60, 84, 0.06)",
        border: "1px solid #e6eef4",
        overflow: "hidden",
        boxSizing: "border-box",
    },
};

export const stageFormStyles = {
    label: {
        display: "block",
        fontSize: 13,
        fontWeight: 600,
        color: "#0c3c54",
        marginBottom: 8,
        fontFamily: "Poppins, sans-serif",
    },
    sectionTitle: {
        fontSize: 14,
        fontWeight: 600,
        color: "#0c3c54",
        margin: "0 0 10px 0",
        fontFamily: "Poppins, sans-serif",
    },
    sectionBox: {
        background: "#f6fafd",
        border: "1px solid #e6eef4",
        borderRadius: 10,
        padding: "12px 14px",
        marginBottom: 12,
    },
    chipBtn: {
        padding: "6px 12px",
        fontSize: 13,
        fontWeight: 600,
        fontFamily: "Poppins, sans-serif",
        borderRadius: 8,
        border: "1px solid #e6eef4",
        cursor: "pointer",
        transition: "all 0.15s ease",
    },
    hint: {
        fontSize: 13,
        color: "#6a7d8c",
        fontFamily: "Poppins, sans-serif",
        marginBottom: 8,
    },
    input: {
        width: "100%",
        padding: "10px 14px",
        fontSize: 14,
        fontFamily: "Poppins, sans-serif",
        color: "#2c3e50",
        background: "#fff",
        border: "1px solid #e6eef4",
        borderRadius: 8,
        outline: "none",
        boxSizing: "border-box",
    },
    textarea: {
        width: "100%",
        padding: "10px 14px",
        fontSize: 14,
        fontFamily: "Poppins, sans-serif",
        color: "#2c3e50",
        background: "#fff",
        border: "1px solid #e6eef4",
        borderRadius: 8,
        outline: "none",
        minHeight: 72,
        resize: "vertical",
        boxSizing: "border-box",
    },
    fieldGroup: {
        marginBottom: 14,
    },
    navRow: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginTop: 16,
        gap: 12,
    },
    navRowEnd: {
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        marginTop: 16,
    },
    navBtn: {
        padding: "8px 18px",
        fontSize: 13,
        fontWeight: 600,
        fontFamily: "Poppins, sans-serif",
        color: "#fff",
        background: "#E06639",
        border: "none",
        borderRadius: 8,
        cursor: "pointer",
        boxShadow: "0 3px 10px rgba(224, 102, 57, 0.25)",
        transition: "background 0.15s ease",
    },
    errorText: {
        fontSize: 12,
        color: "#dc2626",
        fontFamily: "Poppins, sans-serif",
        marginTop: 4,
    },
};

export function StageNavButtons({ onBack, onNext, showBack = true, nextLabel = "Next →", backLabel = "← Back" }) {
    return (
        <div style={showBack ? stageFormStyles.navRow : stageFormStyles.navRowEnd}>
            {showBack && (
                <button type="button" onClick={onBack} style={stageFormStyles.navBtn}>
                    {backLabel}
                </button>
            )}
            <button type="button" onClick={onNext} style={stageFormStyles.navBtn}>
                {nextLabel}
            </button>
        </div>
    );
}